module.exports = __webpack_public_path__ + "img/Module-Div-Wireframes-Responsive.eb5bb21f.svg";